export const DEFAULT_THROTTLE_TIME = 100 //ms

export const throttle = (func, timeout = DEFAULT_THROTTLE_TIME) => {
  let ready = true

  return (...args) => {
    if (!ready) {
      return
    }

    ready = false
    func(...args)
    setTimeout(() => {
      ready = true
    }, timeout)
  }
}
